<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <b-select
          v-model="row.type"
          placeholder="Select type"
          @input="updateCLRowType"
          expanded
        >
          <!--Showing input type-->
          <option value="INPUT">Input</option>
          <option value="IMAGE">Image</option>
          <option value="TEXT">Text</option>
          <option value="QTEXT">Question Text</option>
          <option value="HTMLTEXT">HTML Text</option>
          <option value="HLINE">Line</option>
          <option value="CLOCK">Clock</option>
          <option value="PROTRACTOR">Protractor</option>
          <option value="RULER">Ruler</option>
          <option value="MULTI-CHARS">MultiChars</option>
          <option value="SHAPES">Shapes-I</option>
          <option value="SHAPES-II">Shapes-II</option>
          <option value="SOUND-BOX">Sound Box</option>
        </b-select>
      </div>
      <div class="column">
        <!--SOUND BOX-->
        <div v-if="row.type == 'SOUND-BOX'" class="column is-12 p-3">
          <div class="columns">
            <b-field label="Sound Box Type" class="pr-5">
              <b-select
                v-model="row.sound_box.type"
                placeholder="Select type"
                expanded
              >
                <option value="TTS">Text to Speech</option>
                <option value="CUSTOM">Upload your own</option>
              </b-select>
            </b-field>
            
            <b-field label="Write Text Here">
              <up-textinput
                v-model="row.sound_box.text_input"
                label="Write Text Here"
                labelIcon="mdi mdi-alpha-a-box-outline"
              ></up-textinput>
            </b-field>
          </div>
          <div class="columns">
            <b-input
              class="py-2"
              v-if="row.type == 'HLINE'"
              v-model="row.hline_color"
              placeholder="Add line color"
              expanded
            ></b-input>
          </div>
        </div>
        <!--IF HLINE-->
        <div v-if="row.type == 'HLINE'" class="column is-12 p-3">
          <div class="columns">
            <b-field label="End 1 Type" class="pr-5">
              <b-select
                v-model="row.hline_left_end"
                placeholder="Select type"
                expanded
              >
                <option value="p">Points</option>
                <option value="a">Arrows</option>
              </b-select>
            </b-field>
            <b-field label="End 2 Type" class="pr-5">
              <b-select
                v-model="row.hline_right_end"
                placeholder="Select type"
                expanded
              >
                <option value="p">Points</option>
                <option value="a">Arrows</option>
              </b-select>
            </b-field>
            <b-field label="Transform">
              <up-numberinput
                v-model="row.hline_angle"
                label="Angle"
                :value="row.hline_angle"
                labelIcon="mdi mdi-alpha-a-box-outline"
              ></up-numberinput>
            </b-field>
            <b-field label="Height" class="px-4">
              <up-numberinput
                v-model="row.hline_height"
                label="Height"
                :value="row.hline_height"
                labelIcon="mdi mdi-alpha-a-box-outline"
              ></up-numberinput>
            </b-field>
          </div>
          <div class="columns">
            <b-input
              class="py-2"
              v-if="row.type == 'HLINE'"
              v-model="row.hline_color"
              placeholder="Add line color"
              expanded
            ></b-input>
          </div>
        </div>

        <!--IF SHAPES-->
        <div v-if="row.type == 'SHAPES'">
          <div style="display:flex;">
            <b-select
              v-model="row.shapes.type"
              class="is-3 pr-2"
              placeholder="Select type"
            >
              <option value="S">Squares/Rectangles</option>
              <option value="P">Polygon</option>
              <option value="C">Circle/Oval</option>
            </b-select>
            <up-numberinput
              v-model="row.shapes.rotate_angle"
              label="Angle"
              labelIcon="mdi mdi-alpha-a-box-outline"
            ></up-numberinput>
          </div>

          <!--All Shapes-->
          <style-editor
            v-model="row.shapes.shape_styles"
            show_width
            show_height
            show_bg_color
            show_border_color
            show_border_width
          ></style-editor>

          <!--Squares/Rectangles-->
          <div v-if="row.shapes.type == 'S'" class="columns py-3">
            <up-numberinput
              v-model="row.shapes.square.skew_angle"
              label="Skew-Angle"
              class="px-2"
              labelIcon="mdi mdi-alpha-s-box-outline"
            ></up-numberinput>
            <b-select
              v-model="row.shapes.square.show_angles"
              size="is-small"
              class="is-3 p-2 is-small"
              placeholder="Select Position"
              multiple
            >
              <option value="1">Top Left</option>
              <option value="2">Top Right</option>
              <option value="3">Bottom Right</option>
              <option value="4">Bottom Left</option>
            </b-select>
          </div>

          <!--Polygon-->
          <div v-if="row.shapes.type == 'P'" class="columns py-3">
            <up-numberinput
              v-model="row.shapes.polygon.sides"
              label="Sides"
              class="px-2"
              labelIcon="mdi mdi-alpha-s-box-outline"
            ></up-numberinput>
            <b-select
              v-if="row.shapes.polygon.sides > 2"
              v-model="row.shapes.polygon.show_angles"
              size="is-small"
              class="is-3 p-2 is-small"
              placeholder="Select Side"
              multiple
            >
              <option v-for="i in row.shapes.polygon.sides" :key="i" :value="i"
                >Side {{ i }}</option
              >
            </b-select>
          </div>
        </div>

        <!--IF CLOCK-->
        <set-clock v-if="row.type == 'CLOCK'" v-model="row.clock" />

        <!-- Set Shapes -->
        <set-shapes
          v-if="row.type == 'SHAPES-II'"
          v-model="row.shapes_grid"
        ></set-shapes>

        <!--IF PROTRACTOR-->
        <set-protractor
          v-if="row.type == 'PROTRACTOR'"
          v-model="row.protractor"
        />

        <!--IF RULER-->
        <set-ruler v-if="row.type == 'RULER'" v-model="row.ruler" />

        <!--IF MULTI-CHARS-->
        <set-multi-chars
          v-if="row.type == 'MULTI-CHARS'"
          v-model="row.multi_chars"
        />

        <!--IF IMAGE-->
        <b-select
          v-if="row.type == 'IMAGE'"
          v-model="row.picture_type"
          placeholder="Select Image Type"
          expanded
        >
          <option value="C">Clipart</option>
          <option value="CL">Clipart Layer</option>
          <option value="P">Picture Library</option>
        </b-select>

        <!--IF INPUT-->
        <div v-if="row.type == 'INPUT'" class="columns is-multiline">
          <div class="column is-12">
            <b-field label="Add answer">
              <b-input
                v-model="row.answer"
                placeholder="Add answer"
                expanded
              ></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Input Type">
              <b-select
                v-model="row.input_type"
                placeholder="Input Type"
                expanded
              >
                <option :value="null">Normal</option>
                <option :value="'SM'">Small</option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Add Size">
              <b-select
                v-model="row.input_size"
                placeholder="Add size"
                expanded
              >
                <option value="1">Small</option>
                <option value="2">Medium</option>
                <option value="3">Large</option>
              </b-select>
            </b-field>
          </div>
        </div>

        <b-checkbox
          v-if="row.type == 'INPUT'"
          v-model="row.answer_not_exactly_same"
          >Answer Not Exactly Same</b-checkbox
        >

        <!--IF TEXT-->
        <b-input
          v-if="row.type == 'TEXT' || row.type == 'QTEXT'"
          v-model="row.text"
          type="textarea"
          placeholder="Add text"
          expanded
        ></b-input>
        <div class="columns">
          <div v-if="row.type == 'TEXT'" class="column">
            <b-field label="Font Size">
              <b-input
                v-model="row.font_size"
                placeholder="Font size"
                expanded
              ></b-input>
            </b-field>
          </div>
          <div v-if="row.type == 'TEXT' || row.type == 'QTEXT'" class="column">
            <b-field label="Text Alignment">
              <b-select placeholder="Text Alignment" v-model="row.text_align">
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </b-select>
            </b-field>
          </div>
          <div v-if="row.type == 'TEXT'" class="column">
            <b-field label="Font Weight">
              <b-checkbox v-model="row.is_bold">Bold</b-checkbox>
            </b-field>
          </div>
        </div>

        <basic-quill
          v-if="row.type == 'HTMLTEXT'"
          v-model="row.text"
        ></basic-quill>
      </div>

      <div v-if="row.type == 'IMAGE' && row.picture_type == 'P'" class="column">
        <!--IF IMAGE && TYPE = PICTURE LIBRARY-->
        <picture-library-select
          v-model="row.picture_library"
        ></picture-library-select>
      </div>
    </div>
    <!--IF CLIPART IS SELECTED-->
    <div v-if="row.type == 'IMAGE' && row.picture_type == 'C'">
      <b-collapse :open="isOpenCustomLayerClipart" aria-id="contentIdForA11y1">
        <template #trigger>
          <div
            @click="isOpenCustomLayerClipart = !isOpenCustomLayerClipart"
            class="card-header"
            role="button"
          >
            <p class="card-header-title">Toggle Clipart</p>
          </div>
        </template>
        <div class="columns is-multiline">
          <div class="column is-9">
            <b-pagination
              :total="fetchCliparts.length"
              v-model="current_clipart_page"
              :per-page="clipart_page_items"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
            </b-pagination>
          </div>
          <div class="column is-3">
            <b-numberinput
              v-model="current_clipart_page"
              :controls="false"
            ></b-numberinput>
          </div>
          <div
            v-for="clipart in currentPageCliparts"
            :key="clipart._id"
            style="position: relative; border: 1px solid #ccc"
            class="column is-3 has-text-centered"
          >
            <show-image width="80" :src="clipart.file" />
            <p>
              <b-button
                @click="selectClipartCustomLayoutRow(clipart)"
                type="is-info"
                size="is-small"
                outlined
                >Select</b-button
              >
            </p>
          </div>
        </div>
      </b-collapse>

      <div class="columns">
        <div v-if="row.clipart && row.clipart.file" class="column">
          <span>Currently Selected: </span>
          <show-image
            class="mt-2"
            width="50"
            :src="row.clipart.file"
          />
          <up-textinput label="Text To Speech" v-model="row.clipart_tts_text"></up-textinput>
        </div>
        <div class="column">
          <b-field grouped expanded>
            <b-field label="Width" expanded>
              <b-input size="is-small" v-model="row.width"></b-input>
            </b-field>
            <b-field label="Height" expanded>
              <b-input size="is-small" v-model="row.height"></b-input>
            </b-field>
          </b-field>
        </div>
      </div>
    </div>
    <!--IF CLIPART LAYER IS SELECTED-->
    <set-clipart-layer
      v-if="row.type == 'IMAGE' && row.picture_type == 'CL'"
      :key="`CLO_CLIPART_LAYER`"
      :show_track_count="false"
      v-model="row.layers"
    ></set-clipart-layer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ShowImage from "@/components/General/ShowImage";
import SetClock from "@/components/Question/Clock/SetClock";
import SetShapes from "@/components/Question/Shapes/SetShapes";
import SetProtractor from "@/components/Question/Protractor/SetProtractor";
import SetRuler from "@/components/Question/Ruler/SetRuler";
import SetClipartLayer from "@/components/Question/SetClipartLayer";
import SetMultiChars from "@/components/Question/MultiChars/SetMultiChars";
import BasicQuill from "@/components/Editor/BasicQuill";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
export default {
  props: {
    value: {
      type: Object,
    },
    question_type: {
      type: String,
      default: "CL",
    },
  },
  components: {
    ShowImage,
    SetClipartLayer,
    BasicQuill,
    SetClock,
    SetRuler,
    SetMultiChars,
    SetProtractor,
    StyleEditor,
    UpNumberinput,
    SetShapes,
    UpTextinput
  },
  data() {
    return {
      row: this.value,
      current_clipart_page: 1,
      clipart_page_items: 50,
      isOpenCustomLayerClipart: true,
    };
  },
  computed: {
    ...mapGetters(["fetchCliparts", "fetchPictureLibraries"]),
    currentPageCliparts() {
      return this.fetchCliparts.slice(
        (this.current_clipart_page - 1) * this.clipart_page_items,
        this.current_clipart_page * this.clipart_page_items
      );
    },
  },
  methods: {
    emitData() {
      this.$emit("input", this.row);
    },
    selectClipartCustomLayoutRow(clipart) {
      this.row.clipart = clipart;
    },
    updateCLRowType() {
      if (this.row.type == "SHAPES") {
        if (!this.row.shapes.shape_styles) {
          this.row.shapes.shape_styles = {
            width: 50,
            height: 50,
            bg_color: "#fff",
            border_color: "#000",
          };
        }
      }
    },
    showdata() {
      let canvas = document.getElementById("polygon_canvas");

      let ctx = canvas.getContext("2d");
      ctx.clearRect(
        0,
        0,
        this.row.shapes.shape_styles.width,
        this.row.shapes.shape_styles.height
      );
      let numberOfSides = this.row.shapes.polygon.sides,
        Xcenter = this.row.shapes.shape_styles.width / 2,
        Ycenter = this.row.shapes.shape_styles.height / 2,
        size = Math.min(Xcenter, Ycenter);
      ctx.beginPath();
      ctx.moveTo(Xcenter + size * Math.cos(0), Ycenter + size * Math.sin(0));
      for (let i = 1; i <= numberOfSides; i += 1) {
        ctx.lineTo(
          Xcenter + size * Math.cos((i * 2 * Math.PI) / numberOfSides),
          Ycenter + size * Math.sin((i * 2 * Math.PI) / numberOfSides)
        );
      }
      ctx.fillStyle = this.row.shapes.shape_styles.bg_color;
      ctx.fill();
      ctx.strokeStyle = this.row.shapes.shape_styles.border_color;
      ctx.lineWidth = 1;
      ctx.stroke();
    },
  },
  watch: {
    value: function(new_val) {
      this.row = new_val;
    },
    row: {
      handler() {
        this.emitData();
      },
      deep: true,
    },
  },
};
</script>
